import React from "react";
import {
	AutocompleteInput,
	ReferenceInput,
	required,
	SimpleForm,
	TextField,
} from "react-admin";
import { bookmakersConfig } from "../bookmakers";
import Single from "./inputs/Single";
import Switch from "./inputs/Switch";

const Form = ({ edit = false, ...props }) => (
	<SimpleForm {...props} redirect="list">
		{edit && <TextField source="hash" />}
		{edit && <TextField source="user.name" />}
		<ReferenceInput
			source="bookmaker_id"
			reference="bookmakers"
			validate={required()}
			{...bookmakersConfig.reference}
		>
			<AutocompleteInput optionText="name" />
		</ReferenceInput>
		{edit && <Single />}
		{!edit && <Switch />}
	</SimpleForm>
);
export default Form;
